// extracted by mini-css-extract-plugin
module.exports = {"root":"TrialUpgrade_root__1C-Ei","thankYouMessage":"TrialUpgrade_thankYouMessage__3uZlE","content":"TrialUpgrade_content__4mYaE","button":"TrialUpgrade_button___oagh"};